import { Controller } from "@hotwired/stimulus"
import Toastify from 'toastify-js';


export default class extends Controller {
  static targets = ["firstStep", "secondStep", "paymentPlan"]

  connect() {
    this.steps = ["firstStep", "secondStep"];
    this.updateStepBar();
  }

  goSecondStep() {
    const paymentPlan = this.paymentPlanTargets.find(option => option.checked);
    if (paymentPlan == undefined) {
      Toastify({
        text: "Selecione um plano de pagamento",
        duration: 3000,
        gravity: "bottom",
        position: "right",
        style: { background: "#102f6d" },
      }).showToast();
      return;
    }
    this.firstStepTarget.classList.add("hidden");
    this.secondStepTarget.classList.remove("hidden");
    this.offsetTop();
  }

  prevStep(e) {
    const stepElement = e.currentTarget.parentNode.parentNode;
    const currentStep = stepElement.dataset.stepMatriculationTarget;
    const currentStepPos = this.steps.indexOf(currentStep);

    stepElement.classList.add("hidden");
    const toShow = document.querySelector(`div[data-step-matriculation-target*=${this.steps[currentStepPos - 1]}]`);
    toShow.classList.remove("hidden");
  }

  offsetTop() {
    window.scrollTo(0, 0);
  }

  updateStepBar() {
    this.dispatchEvent('course');
    this.dispatchEvent('modality');
    this.dispatchEvent('pole');
    this.dispatchEvent('ingress-type');
  }

  dispatchEvent(step, action = 'active') {
    const event = new CustomEvent("stepbar:update", {
      detail: { step: step, action: action }, 
      bubbles: true 
    });
    document.querySelector('body').dispatchEvent(event);
  }
}